module.exports = __webpack_public_path__ + "img/h-logo.5a5ca60a.jpg";